<main class="destinations-page">
  <section class="destinations__container">
    <header class="destinations__header">
      <div>
        <h1>
          {{ 'destinations.title' | translate }}
        </h1>
        <p>{{ 'destinations.subtitle' | translate }}</p>
      </div>
      <button type="button"
              class="primary-btn"
              (click)="openCreatePanel()">
        {{ 'destinations.actions.new' | translate }}
      </button>
    </header>


    <div class="destinations__toolbar">
      <div class="toolbar-summary">
        <div class="status-pills">
          <button
            *ngFor="let status of availableStatuses"
            type="button"
            class="status-pill"
            [class.is-active]="statusFilters[status.id]"
            [style.--status-color]="statusColors[status.id]"
            [attr.aria-pressed]="statusFilters[status.id]"
            [attr.title]="status.labelKey | translate"
            (click)="toggleStatusFilter(status.id)">
            <span class="status-pill__count" aria-hidden="true">{{ statusCounts[status.id] || 0 }}</span>
            <span class="status-pill__label">{{ status.labelKey | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="destinations__filters surface-card">
      <div class="destinations__filter-field">
        <label>{{ 'destinations.filters.search' | translate }}</label>
        <div class="destinations__filter-control">
          <input type="search"
                 [value]="searchTerm"
                 [placeholder]="'destinations.filters.searchPlaceholder' | translate"
                 (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>

    <div class="destinations__layout">
      <div class="destinations__card surface-card">
        <div class="destinations__table-wrapper">
          <div class="destinations__table-header" *ngIf="!isLoading && !loadingError && filteredDestinations.length">
            <span>{{ 'destinations.table.connection' | translate }}</span>
            <span>{{ 'destinations.table.name' | translate }}</span>
            <span>{{ 'destinations.table.owner' | translate }}</span>
            <span>{{ 'destinations.table.type' | translate }}</span>
            <span>{{ 'destinations.table.activation' | translate }}</span>
            <span>{{ 'destinations.table.active' | translate }}</span>
            <span class="destinations__header-spacer" aria-hidden="true"></span>
          </div>
          <div class="destinations__list">
            <p class="list-status" *ngIf="isLoading">{{ 'destinations.states.loading' | translate }}</p>
            <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

            <ng-container *ngIf="!isLoading && !loadingError && filteredDestinations.length; else destinationsState">
              <div class="destinations__row" *ngFor="let destination of paginatedDestinations">
                <span>
                  <span class="destinations__connection"
                        [ngClass]="getConnectionStatusClass(destination.connectionStatus)"></span>
                  <span class="destinations__connection-label">{{ destination.connectionStatus || '—' }}</span>
                </span>
                <span>
                  <div class="destinations__cell-title">{{ destination.name }}</div>
                  <div class="destinations__cell-subtitle">ID: {{ destination.id }}</div>
                </span>
                <span class="destinations__owner">
                  <div class="destinations__owner-name">{{ destination.entity }}</div>
                  <small>{{ destination.entityId || '-' }}</small>
                </span>
                <span>
                  <strong>{{ destination.connectorName || '—' }}</strong>
                </span>
                <span>{{ destination.activationType || '—' }}</span>
                <span>
                  <div class="destinations__active-cell">
                    <label class="destinations__toggle">
                      <input type="checkbox"
                             [checked]="destination.status === 'active'"
                             (change)="toggleActivation(destination)">
                      <span class="destinations__toggle-slider"></span>
                    </label>
                  </div>
                </span>
                <div class="destinations__actions">
                  <button type="button"
                          class="destinations__action-trigger"
                          aria-haspopup="menu"
                          [attr.aria-expanded]="activeActionMenuId === destination.id"
                          (click)="toggleActionsMenu(destination, $event)">
                    <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                      <circle cx="10" cy="4" r="1.5" />
                      <circle cx="10" cy="10" r="1.5" />
                      <circle cx="10" cy="16" r="1.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-template #destinationsState>
              <p class="list-status" *ngIf="!isLoading && !loadingError && !filteredDestinations.length">
                {{ 'destinations.states.empty' | translate }}
              </p>
            </ng-template>
          </div>
        </div>

        <div class="pagination-controls" *ngIf="!isLoading && filteredDestinations.length">
          <div class="page-size">
            <label>{{ 'destinations.pagination.rowsPerPage' | translate }}</label>
            <select [value]="pageSize" (change)="changePageSize($event)">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <div class="page-navigation">
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 0">
              ‹
            </button>
            <span class="page-info">
              {{ 'destinations.pagination.page' | translate:{ current: ((currentPage + 1) | number:'1.0-0':locale), total: (totalPages | number:'1.0-0':locale) } }}
            </span>
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage + 1 >= totalPages">
              ›
            </button>
          </div>
        </div>

        <ng-container *ngIf="activeActionItem as menuItem">
          <div class="destinations__action-menu"
               role="menu"
               [style.top.px]="actionMenuPosition.top"
               [style.left.px]="actionMenuPosition.left"
               [style.--destinations-action-arrow-left]="actionMenuArrowOffset + 'px'">
            <div class="destinations__action-menu-label">{{ 'destinations.actions.menuTitle' | translate }}</div>
            <button type="button"
                    class="destinations__action-item"
                    (click)="openEditPanel(menuItem)">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'destinations.actions.edit' | translate }}</span>
            </button>
            <button type="button" class="destinations__action-item" (click)="toggleActivation(menuItem)">
              <span class="action-icon action-icon--pause" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="6" y="4" width="2.5" height="12" rx="1" />
                  <rect x="11.5" y="4" width="2.5" height="12" rx="1" />
                </svg>
              </span>
              <span>
                {{ menuItem.status === 'active' ? ('destinations.actions.deactivate' | translate) : ('destinations.actions.activate' | translate) }}
              </span>
            </button>
            <button type="button" class="destinations__action-item danger" (click)="deleteDestination(menuItem)">
              <span class="action-icon action-icon--delete" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M6 6h8l-.8 10.5H6.8L6 6z" />
                  <path d="M4 5h12" />
                  <path d="M8 5V3h4v2" />
                </svg>
              </span>
              <span>{{ 'destinations.actions.delete' | translate }}</span>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="destinations__form-wrapper" *ngIf="panelOpen">
        <app-destinations-form
          #destinationForm
          [destinationTypes]="destinationTypes"
          [hasGlobalDataScope]="hasGlobalDataScope"
          [ownerEntityOptions]="ownerEntityOptions"
          (saved)="handleFormSaved()"
          (cancelled)="closePanel()"
        ></app-destinations-form>
      </div>
    </div>
  </section>
</main>
